import { SetStateAction, useEffect, useState, useContext } from 'react';
import ReactCodeInput from "react-code-input";
import { useNavigate } from "react-router-dom";

import { DataContext } from 'providers/data';

import { Typography, Box, Collapse } from '@mui/material';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';

import { ContentReactCode, LinkExtermal } from 'components/views/ContentForgot/styles';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcIturinOk } from 'assets/icons/ic-iturin-ok.svg';
import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';

type ParamsToken = {
    show: boolean;
    isTokenSuccess: boolean;
    handleSendToken: (sendToken: string) => void;
    cancelSendToken: (sendToken: boolean) => void;
}

type ParamsError = {
    show: boolean;
    typeError: 0 | 1 | 2;
}

export const SuccessForgot = ({ show, login }: { show: boolean, login: string }) => {
    const { handleClearAuthentication } = useContext(DataContext);
    const navigate = useNavigate();

    return (
        <Collapse in={show}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                'button': {
                    width: '100%',
                    height: '2.5rem',
                    marginTop: '2.25rem',
                    maxWidth: '20.6875rem'
                }
            }}>
                <IcIturinOk />
                <Box sx={{
                    border: '1.5px solid rgba(151, 201, 61, 0.45)',
                    borderRadius: '10px',
                    height: '3.125rem',
                    padding: '.8rem 5.1rem 0',
                    marginTop: '-34px',
                    backgroundColor: 'white'
                }}>
                    <Typography fontSize='1.5625rem' textAlign='center' fontWeight={700}>
                        Dados salvos!
                    </Typography>
                </Box>
                <ButtonRectangle name="ACESSAR" onClick={() => { navigate('/', { state: { login: login } }); handleClearAuthentication(); }} />
            </Box>
        </Collapse>
    );
}

export const Tokenforgot = ({ show, cancelSendToken, isTokenSuccess, handleSendToken }: ParamsToken) => {
    const [pinCode, setPinCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [isPinCodeValid, setIsPinCodeValid] = useState(true);

    const [accountantTime, setAccountantTime] = useState(60);

    const handlePinChange = (pinCode: SetStateAction<string>) => {
        setPinCode(pinCode);
    }

    const handleCancelSendToken = () => {
        cancelSendToken(false);
    }

    useEffect(() => {
        if (accountantTime > 0 && show) {
            setTimeout(() => setAccountantTime(accountantTime - 1), 1000);
        } else if (accountantTime <= 0 && show) {
            handleCancelSendToken();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountantTime, show]);

    useEffect(() => {
        setIsPinCodeValid(isTokenSuccess);
    }, [isTokenSuccess]);

    useEffect(() => {
        if (pinCode?.length > 5) {
            setDisabledBtn(false);
        } else {
            setDisabledBtn(true);
        }
    }, [pinCode]);

    useEffect(() => {
        setIsLoading(false);
    }, [isTokenSuccess]);

    useEffect(() => {
        setAccountantTime(60);
    }, [show]);

    return (
        <Collapse in={show}>
            <ContentReactCode invalidPin={!isPinCodeValid ? 'error' : 'success'}>
                <Typography variant="body2" color='error.main' textAlign='start' paddingBottom='.5rem' sx={{ height: '20px' }}>
                    {!isPinCodeValid && 'Código inválido, por favor tente novamente.'}
                </Typography>

                <ReactCodeInput
                    type='number'
                    fields={6}
                    name=""
                    inputMode="tel"
                    onChange={handlePinChange}
                    value={pinCode}
                    inputStyle={{
                        width: '3.125rem',
                        height: '3.125rem',
                        borderRadius: '5px',
                        fontSize: '1.875rem',
                        textAlign: 'center',
                        paddingTop: '5px'
                    }}
                />
            </ContentReactCode>

            <Box sx={{ 'button': { height: '2.5rem', marginTop: { xs: '.9375rem', md: '1.5625rem' } } }}>
                <ButtonRectangle
                    name='VALIDAR CÓDIGO'
                    disabled={disabledBtn}
                    loadingBtn={isLoading}
                    onClick={() => { setIsLoading(true); handleSendToken(pinCode) }}
                />
                <ButtonOutlined name="Cancelar" onClick={() => handleCancelSendToken()} />

                <Typography variant='subtitle2' color='#ABAEAE' sx={{ paddingTop: { xs: '1.1875rem', md: '3.375rem' } }}>
                    Reenvio do token em 00:{accountantTime}
                </Typography>
            </Box>
        </Collapse>
    );
}

export const ErrosAccess = ({ show, typeError }: ParamsError) => {
    const { handleClearAuthentication } = useContext(DataContext);
    const navigate = useNavigate();

    return (
        <Collapse in={show}>
            <Box sx={{
                display: 'flex',
                margin: '0 auto',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: '26.125rem',
                padding: {
                    xs: '0 1rem',
                    md: '0',
                },
                'button': {
                    width: '100%',
                    height: '2.5rem',
                    marginTop: '.9375rem',
                }
            }}>
                {typeError !== 2 && <IcIturinOk />}
                {typeError === 2 && <IcIturinCoverage />}
                <Box sx={{
                    border: '1.5px solid rgba(151, 201, 61, 0.45)',
                    borderRadius: '10px',
                    padding: 0,
                    width: '100%',
                    backgroundColor: 'white',
                    margin: '-34px 0 1.5625rem'
                }}>
                    <Typography textAlign='center' sx={{ fontSize: { xs: '1rem', md: '1.125rem' }, padding: '1.1875rem 0 1rem', lineHeight: '21px' }}>
                        {typeError === 0 &&
                            <>
                                Identificamos que você já tem um cadastro! <br />
                                <strong>Mas isso é ainda melhor, você deseja:</strong>
                            </>
                        }
                        {typeError === 1 &&
                            <>
                                <strong>Identificamos que sua conta é de FROTISTA.</strong>
                                <br />
                                Temos um canal exclusivo, ligue pra gente e conheça!
                            </>
                        }
                        {typeError === 2 &&
                            <>
                                <strong>Não encontramos seus dados.</strong>
                                <br />
                                Nossa área do cliente é exclusiva para clientes!
                            </>
                        }
                    </Typography>
                </Box>
                {typeError === 0 &&
                    <>
                        <ButtonRectangle name="ACESSAR" onClick={() => { navigate('/'); handleClearAuthentication(); }} />
                        <ButtonOutlined name="RECUPERAR MEU LOGIN" onClick={() => { navigate('/esqueci-login'); handleClearAuthentication(); }} />
                        <ButtonOutlined name="RECUPERAR MINHA SENHA" onClick={() => { navigate('/esqueci-senha'); handleClearAuthentication(); }} />
                    </>
                }

                {typeError === 1 &&
                    <>
                        <Typography fontSize='.75rem' lineHeight='1rem' textAlign='start' width='100%'>
                            São Paulo
                        </Typography>
                        <LinkExtermal href="tel:1145040443">
                            (11) 4504-0443
                            <LocalPhoneOutlinedIcon />
                        </LinkExtermal>

                        <Typography fontSize='.75rem' lineHeight='1rem' textAlign='start' width='100%' marginTop='1.375rem'>
                            Outras localidades
                        </Typography>
                        <LinkExtermal href="tel:08007500012">
                            0800 750 0012
                            <LocalPhoneOutlinedIcon />
                        </LinkExtermal>
                    </>
                }

                {typeError === 2 &&
                    <Box sx={{ width: '100%', 'button': { height: '3.125rem', margin: '0 0 1.25rem' } }}>
                        <ButtonRectangle name="JÁ SOU CLIENTE" onClick={() => navigate('/')} />
                        <ButtonOutlined name="QUERO SER CLIENTE" onClick={() => window.open('https://loja.ituran.com.br/')} />
                    </Box>
                }
            </Box>
        </Collapse>
    );
}